/* Contact form: the Project type field follows the chosen topic, and links can preselect a topic
   or project type with ?topic=…&project=… (for example from the Services page). */
(function () {
  function setup(form) {
    if (form.dataset.contactReady) return;
    form.dataset.contactReady = 'true';

    var projectTopic = (form.dataset.projectTopic || '').trim().toLowerCase();
    var field = form.querySelector('[data-project-field]');
    var select = field && field.querySelector('select');
    var radios = form.querySelectorAll('input[name="contact[topic]"]');
    var params = new URLSearchParams(window.location.search);

    function sync() {
      if (!field || !field.hasAttribute('data-project-toggle')) return;
      var checked = form.querySelector('input[name="contact[topic]"]:checked');
      var show = !!checked && checked.value.trim().toLowerCase() === projectTopic;
      field.hidden = !show;
      if (select) select.disabled = !show;
    }

    var wantedTopic = (params.get('topic') || '').trim().toLowerCase();
    if (wantedTopic) {
      radios.forEach(function (radio) {
        var value = radio.value.trim().toLowerCase();
        if (value === wantedTopic || (wantedTopic === 'project' && value === projectTopic)) radio.checked = true;
      });
    }

    var wantedProject = (params.get('project') || '').trim().toLowerCase();
    if (wantedProject && select) {
      Array.prototype.forEach.call(select.options, function (option) {
        if (option.value && option.value.trim().toLowerCase() === wantedProject) select.value = option.value;
      });
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', sync);
    });
    sync();
  }

  function init(root) {
    (root || document).querySelectorAll('form[data-contact-form]').forEach(setup);
  }

  init();
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
